<template>
  <label
    :class="labelClasses"
    data-cy="ds-option-label"
  >
    <slot :class="DS_OPTION_LABEL_CLASSES.Input" />

    <component :is="renderLabelContent" />
  </label>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { DS_OPTION_LABEL_CLASSES } from "@/src/design_system/form_elements/shared_modules/option_label/constants/classes";
import { useRenderLabelContent } from "@/src/design_system/form_elements/shared_modules/option_label/composables/useRenderLabelContent";
import { DSOptionLabelProps } from "@/src/design_system/form_elements/shared_modules/option_label/types/props";
import { DS_DIRECTION } from "@/src/design_system/shared/types/direction";
import { useStateClasses } from "@/src/design_system/shared/composables/useStateClasses";
import { getPaletteClass } from "@/src/design_system/shared_modules/palette/utils/palette";

const props = withDefaults(defineProps<DSOptionLabelProps>(), {
  disabled: false,
  direction: DS_DIRECTION.Horizontally,
  hasError: false,
  selected: false,
  tooltip: undefined,
});

const { stateClasses } = useStateClasses(props);

const labelClasses = computed(() => {
  return {
    [DS_OPTION_LABEL_CLASSES.Root]: true,
    [DS_OPTION_LABEL_CLASSES.WithIcon]: !!props.option.icon || props.option.icon === null,
    [DS_OPTION_LABEL_CLASSES.Vertical]: props.direction === DS_DIRECTION.Vertically,
    [DS_OPTION_LABEL_CLASSES.Horizontal]: props.direction === DS_DIRECTION.Horizontally,
    [DS_OPTION_LABEL_CLASSES.Tile]: props.option.icon || props.option.description,
    [getPaletteClass(props.option.color)]: props.option.color,
    [DS_OPTION_LABEL_CLASSES.Selected]: props.selected,
    [DS_OPTION_LABEL_CLASSES.WithColor]: !!props.option.color || props.option.color === null,
    [DS_OPTION_LABEL_CLASSES.Null]: props.option.color === null || props.option.icon === null,
    ...stateClasses.value,
  };
});

const { renderLabelContent } = useRenderLabelContent(
  computed(() => props.option),
  computed(() => props.tooltip)
);
</script>
